import {defineNuxtPlugin} from "#app";

export default defineNuxtPlugin(async (nuxtApp) => {
  const sizeCookie = useCookie('clientSize');
  const heightCookie = useCookie('clientHeight');
  nuxtApp.hook('app:mounted', async () => {
    let width, height
    if (import.meta.client) {
      width = window.innerWidth
      height = window.innerHeight
      if (width > 1680) {
        sizeCookie.value = 'large'
      } else if (width > 1365) {
        sizeCookie.value = 'medium'
      } else {
        sizeCookie.value = 'small'
      }

      if (height >= 700) {
        heightCookie.value = 'large'
      } else {
        heightCookie.value = 'small'
      }
    }
  })
})